import React, { useEffect, useState } from 'react'
import { selectPeaksObject, getAllReportingPeaks } from '../../lib/utilities/selector';
import { useSelector } from 'react-redux';
import QaAreaChart from '../shared/QaAreaChart';
import QaRetentionChart from '../shared/qaRetentionChart';
import { MdKeyboardBackspace } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import ResizableDiv from '../shared/ResizableDiv';
import BackButton from '../shared/BackButton';




function Qa() {
  const peaksObject = useSelector(selectPeaksObject);
  const allReportingPeaks = useSelector(getAllReportingPeaks);
  const stdFiles = useSelector((s) => s.results.stdFiles);
  const qcFiles = useSelector((s) => s.results.qcFiles);
  const unkFiles = useSelector((s) => s.results.unkFiles);
  const [selectedPeak, setSelectedPeak] = useState(null);
  const [areaChartData, setAreaChartData] = useState([]);
  const [retentionChartData, setRetentionChartData] = useState([]);
  const [maxEntryName, setMaxEntryName] = useState(null);
    const navigate = useNavigate()
  

  // Auto-select the first visible peak when component mounts
  useEffect(() => {
    if (peaksObject.length > 0) {
      const firstVisiblePeak = peaksObject.find(peak => peak.show);
      if (firstVisiblePeak) {
        handleButtonClick(firstVisiblePeak, peaksObject.indexOf(firstVisiblePeak));
      }
    }
  }, [peaksObject]); // Run when `peaksObject` changes


  const handleButtonClick = (peak, index) => {
    setSelectedPeak(peak.peak); 
    const formattedData = extractConcentrations(peak);
    setAreaChartData(formattedData);

  const xPeaksData = extractXPeaksData(index);
    setRetentionChartData(xPeaksData);
    // console.log(xPeaksData)

  };

  const extractXPeaksData = (peakIndex) => {
    // Find the reporting group key matching peaksObject[peakIndex].peak
    const peakVal = peaksObject[peakIndex]?.peak;
    if (peakVal == null) return [];
    const pv = Number(peakVal);
    let groupKey = null;
    Object.entries(allReportingPeaks || {}).some(([rk, list]) => {
      const arr = Array.isArray(list) ? list : [];
      if (arr.some((nom) => Math.abs(Number(nom) - pv) <= 1e-3)) { groupKey = rk; return true; }
      return false;
    });
    if (!groupKey) return [];
  const byFile = new Map();
    const addFromFiles = (files) => {
      Object.entries(files || {}).forEach(([fname, file]) => {
        // Handle both old and new file structure
        const fileData = file?.fileData || file;
        const res = fileData?.result || {};
        Object.values(res).forEach((r) => {
          if (!r?.to_analyze) return;
          const peaks = r.peaks || {};
          Object.entries(peaks).forEach(([k, v]) => {
            const val = parseFloat(k);
            const list = allReportingPeaks[groupKey] || [];
            if (list.some((nom) => Math.abs(nom - val) <= 1e-3)) {
        if (v?.x_peak != null) byFile.set(fname, v.x_peak);
            }
          });
        });
      });
    };
    addFromFiles(stdFiles);
    addFromFiles(qcFiles);
    addFromFiles(unkFiles);
  return Array.from(byFile.entries()).map(([name, value]) => ({ name, value }));
  };

  const extractConcentrations = (peak) => {
    const formatData = (dataObj) =>
      dataObj
        ? Object.entries(dataObj).map(([key, value]) => ({ name: key, value: value }))
        : [];
  
    // Extract std and qc concentrations
    const stdData = formatData(peak.stdConcentrations);
    const qcData = formatData(
      peak.qcConcentrations?.reduce((acc, obj) => ({ ...acc, ...obj }), {}) || {}
    );
  
    // Combine std and qc data
    const allData = [...stdData, ...qcData];
  
    // Find the file with the highest value
    if (allData.length > 0) {
      const maxEntry = allData.reduce((max, entry) =>
        entry.value > max.value ? entry : max
      );
  
      // console.log("File with highest value:", maxEntry.name, "Value:", maxEntry.value);
      setMaxEntryName(maxEntry.name);
    }
  
    // Return the formatted data
    return allData.concat(
      formatData(
        peak.unkConcentrations?.reduce((acc, obj) => ({ ...acc, ...obj }), {}) || {}
      )
    );
  };





  return (
    <div className='flex flex-col overflow-hidden'>
      <div className='fixed bottom-8 right-8 z-40'>
        <BackButton to={'/configuration/showAllFiles'} />
      </div>
        <ResizableDiv initialHeight={300} minHeight={350} className='rounded-sm shadow p-5 mx-10 mt-5'>
            {areaChartData && <QaAreaChart data={areaChartData} maxEntryName={maxEntryName}/>}
        </ResizableDiv>
        <ResizableDiv initialHeight={400} minHeight={400} className='rounded-sm shadow p-5 mx-10 mt-5'>
            {retentionChartData && <QaRetentionChart data={retentionChartData} />}
        </ResizableDiv>
        <div className='flex-grow flex w-full justify-center items-center overflow-x-auto min-w-0 px-10 mt-8 mb-16'>
            <table className="table-auto border-collapse border border-gray-300 w-full">
                <thead>
                    <tr className='bg-customeBlack text-white'>
                        {peaksObject.map((peak) => {
                            if (peak.show) {
                                return (
                                    <th
                                        key={peak.peak}
                                        className={`border border-gray-300 px-4 py-2 text-center ${
                                            selectedPeak === peak.peak ? 'bg-cyan-500' : ''
                                        }`}
                                    >
                                        {peak.name}
                                    </th>

                                );
                            }
                            return null;
                            })}
                    </tr>
                </thead>
                <tbody>
            
                    <tr>
                        {peaksObject.map((peak, index) => {
                            if (peak.show) {
                                return (
                                    <td
                                        key={peak.peak}
                                        className={`border border-gray-300 px-4 py-2 text-center ${
                                            selectedPeak === peak.peak ? 'bg-cyan-50' : ''
                                        }`}
                                    >
                                        <button
                                            className={`mt-2 px-4 py-2 text-white hover:bg-gray-600 rounded-sm w-[100px] ${
                                                selectedPeak === peak.peak
                                                    ? 'bg-cyan-500'
                                                    : 'bg-gray-400'
                                            }`}
                                            onClick={() => handleButtonClick(peak, index)}
                                        >
                                            {selectedPeak === peak.peak ? 'Selected' : 'Select'}
                                        </button>
                                    </td>
                                );
                            }
                            return null;
                          })}
                    </tr>
                </tbody>
            </table>
        </div>

        {/* <div className='flex justify-end items-center  mb-5 mr-36 flex-shrink-0'>                 
            <button 
                // disabled={!allTcValuesFilled}
                onClick={() => {}} 
                className={`flex-row flex items-center justify-center bg-buttonColorActive text-white font-semibold w-40 p-3 rounded-md self-center disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed hover:bg-customeOrange hover:text-customeBlack`}
                >Back 
            </button>
        </div> */}
        
</div>
  )
}

export default Qa